// URL used for initiating authorization request
export const authorityUrl = process.env.REACT_APP_MSAL_AUTHORITY;

// End point URL for Power BI API
export const powerBiApiUrl: string = "https://api.powerbi.com/";

// Scope for securing access token
export const scopeBase: string[] = ["https://analysis.windows.net/powerbi/api/Report.Read.All"];

// Client Id (Application Id) of the AAD app.
export const clientId = process.env.REACT_APP_MSAL_CLIENT_ID;